import {
  deleteAction,
  getAction,
  putAction,
  postAction,
  postActionBody
} from '@/api/manage'
import store from '../store'
//获取字典
export function ajaxGetDictItems(code) {
  // code 是传进来的字典编码 
  // state 如果是true重新从后台请求字典更新到本地缓存中 默认不填
  return new Promise((resolve, reject) => {
    //先去本地缓存查询有没有字典
    let allDictItems = JSON.parse(JSON.stringify(store.state.dictionary))
    for (const key in allDictItems) {
      if (code == key) {
        let jsondata = {
          code: 0,
          message: "",
          result: allDictItems[key],
          success: true,
        }
        resolve(jsondata)
      }
    }
  })
}
export const getAdmissionListBySchoolNameApi = (params) => getAction("AIChat/getAdmissionBySchoolName",params)
export const getSchoolListByDegreeNameApi = (params) => getAction("AIChat/getSchoolListByDegreeName",params)
//获取单个字典
// export const ajaxGetDictItems = (code, params) => getAction(jeecg.jeecgSystem + `/sys/dict/getDictItems/${code}`, params);
//获取用所有字典
export const queryAllDictItems = (params) => getAction("/sys/dict/queryAllDictItems", params);
//获取用户信息
export const userqueryById = (params) => getAction("/course/user/selectById", params);

// 获取会员卡
export const getVipCard = (params) => getAction("/gkCard/queryByGkUserId", params);

//更新用户信息
export const updateSelective = (params) => postAction("/gkUser/updateSelective", params);

export const getResponseCountApi = (params) => getAction("/gkUser/getResponseCount", params);

export const updateResponseCountApi = (params) => getAction("/gkUser/updateResponseCount", params);

//获取专业12级
export const gkYClassallList = (params) => getAction("/gkDegree/allList", params);
//获取专业123级
export const gkClassallList = (params) => getAction("/gkDegree/degreeList", params);
//获取教师列表
export const getTeacherPage = (params) => getAction("/teacher/getTeacherList",params)
//获取某位教师
export const getTeacherDetail = (params) => getAction("/teacher/queryById",params)
//查询专业分页列表
//模糊查询百问百答
export const getQuestionList = (params) => getAction("gkQuestion/getAllQuestionByQuestion",params)
export const gkYClassList = (params) => getAction("/gkDegreeLevel/classList", params);
export const gkYClassListSubject = (params) => getAction("/gkDegreeLevel/classListSubject", params);
//查询专业分页列表
export const selectProfessionalList = (params) => getAction("/gkDegree/selectProfessionalList", params);

//点击增加热度
export const clickAddHot = (params) => getAction("/gkMessage/clickHotAdd",params);



//查询专业详情
export const gkYProfessionalqueryById = (params) => getAction("/gkDegree/queryById", params);
//查询高考资讯
export const getGkMessage = (params) => getAction("/gkMessage/getAllMessage",params)
//按热度查询高考资讯
export const getHotGkMessage = (params) => getAction("/gkMessage/getAllHotMessage",params)
export const getAllQuestionChat = (params) => getAction("/gkQuestionChat/getAllDataList",params)
//分页查询高考资讯
export const getGkMessageList = (params) => getAction("gkMessage/list",params)
export const getQuestionGkMessageList = (params) => getAction("gkMessage/listOfQuestion",params)
export const getCollegeGkMessageList = (params) => getAction("gkMessage/listOfCollege",params)
export const getProEncyGkMessageList = (params) => getAction("gkMessage/listOfProEncy",params)
export const getAdmissionGkMessageList = (params) => getAction("gkMessage/listOfAdmission",params)
export const getGkMessageListDisplay = (params) => getAction("gkMessage/listDisplay",params)
export const getGkMessageListByType = (params) => getAction("gkMessage/listByType",params)
//通过id查询资讯管理
export const queryGkMessageById = (params) => getAction("gkMessage/queryById",params)
//百问百答分页
export const getGkQuestionList = (params) => getAction("gkQuestion/list",params)
//查询百问百答
export const getAllQuestion = (params) => getAction("/gkQuestion/getAllQuestion",params)
//搜索资讯列表
export const queryMessageList = (params) => getAction("/gkMessage/getAllMessageListByTitle",params)
//查询专业详情
export const foretypeList = (params) => getAction("/examination/fore/typeList", params);
//手动填报列表
export const aiaiList = (params) => getAction("/AISelector/aiList", params);

//自动填报列表
export const autoAiList = (params) => getAction("/AISelector/autoAiList", params);

export const autoArtAiList = (params) => getAction("/AISelector/autoArtAiList", params);

export const autoPeAiList = (params) => getAction("/AISelector/autoPeAiList", params);

export const autoSpringAiList = (params) => getAction("/AISelector/autoSpringAiList", params);
//添加志愿
export const gkUseraddAsp = (params) => postAction("/AISelector/addApplicationItem", params);
//获取志愿列表
export const getZyList = (params) => getAction("/AISelector/getApplicationList", params);
//移除志愿
export const deleteAsp = (params) => deleteAction("/gkApplication/deleteApplication", params);
//获取学校列表
export const getRankSchoolList = (params) => getAction("/schoolRuankeRank/list", params);
//获取学校列表
export const setSchoolList = (params) => getAction("/gkSchool/getSchoolList", params);

export const chooseSubjectBySchool = (params) => getAction("/gkSchool/chooseSubjectBySchool", params);
//获取学校详情
export const querySchoolById = (params) => getAction("/gkSchool/querySchoolById", params);
//获取学校专业
export const getSchoolSpeList = (params) => getAction("/gkSchool/getSchoolSpeList", params);
//查询开设专业
export const getSchoolZy = (params) => getAction("/gkSchoolDegree/getSchoolZy", params);
//查询分数线
export const getScoreLine = (params) => getAction("/gkSchoolRank/list", params);
//查询开招生情况
export const getEnrollment = (params) => getAction("/gkApplicationPlan/getEnrollment", params);
//移除志愿
export const gkAspirationdelete = (params) => deleteAction("/gkApplication/deleteApplication", params);
//首页志愿列表
export const gkSpecialtyOrder = (params) => getAction("/examination/fore/specialtyOrderList", params);
//第四轮学科评估
export const getSubjectByFour = (params) => getAction("/gkDegreeAssess/getSubjectByFour", params);
//第四轮学科评估
export const getSubjectByDegreeApi = (params) => getAction("/gkDegreeAssess/getSubjectByDegree", params);
//一分一段
export const subsection = (params) => getAction("/examination/fore/sectionList", params);
//移除志愿
export const deleteAspByUserId = (params) => deleteAction("/gkApplication/deleteAspByUserId", params);
//获取已填写志愿数量
export const getAlreadyAsp = (params) => getAction("/gkApplication/getAlreadyApplication", params);
//获取问题列表
export const questionList = (params) => getAction("/examination/fore/questionList", params);
//获取问题详情
export const questionById = (params) => getAction("/gkQuestion/queryById", params);
//生成订单
export const gkOrdersadd = (params) => postAction("/gkOrders/addOrders", params);
//微信下单，返回生成微信二维码所需地址
export const createOrder = (params) => postActionBody("/examination/wxpayment/createOrder", params);
//生成微信二维码   --废弃
export const getqrcode = (params) => postActionBody("/examination/wxpayment/createScanPayQrcodeMode2", params);
//获取订单支付状态
export const queryByOrderNum = (params) => getAction("/gkOrders/queryByOrderNum", params);
//支付宝下单，返回生成支付宝二维码所需地址
export const aliCreateOrder = (params) => getAction("/examination/aliPay/aliCreateOrder2", params);
//订单列表
export const gkOrderslist = (params) => getAction("/gkOrders/list", params);
//查询vip金额
export const getVipMoney = (params) => getAction("/gkOrders/getVipMoney", params);
//查询会员有效期
export const selectVipTime = (params) => getAction("/gkOrders/selectVipTime", params);
//查询试用期有效期

export const selectTryVipTime = (params) => getAction("/gkOrders/selectTryVipTime", params);

// 获取招生政策、院校招生、专业百科信息
export const getExamMessage = (params) => getAction("/gkMessage/getAllMessage", params);
export const getRecommendSchool = (params) => getAction("/gkSchool/getRecommendSchool", params);

export const getRecommendSchoolByScore = (params) => getAction("/gkSchool/recommendSchoolByScore", params);

export const getRecommendTeachers = (params) => getAction("/teacher/getTeachers", params);

export const getQuestion = (params) => getAction("/gkQuestion/getQuestion", params);

export const getSchoolNum = (params) => getAction("/gkSelectSubject/getSchoolNum", params);

export const getDegreeNum = (params) => getAction("/gkSelectSubject/getDegreeNum", params);

export const getEachDegreeNum = (params) => getAction("/gkSelectSubject/getEachDegreeNum", params);

export const getSubjectCombination = (params) => getAction("/gkSelectSubject/getSubjectCombination", params);

export const chooseDegreeSubject = (params) => getAction("/gkSelectSubject/chooseDegreeSubject", params);

export const getSchoolSubject = (params) => getAction("/gkSelectSubject/getSchoolSubject", params);

export const getTargetSchoolDegree = (params) => getAction("/gkUserSchoolWork/queryBygkUserId", params);

export const getTargetSchool = (params) => getAction("/gkUserTargetSchool/queryByGkUserId",params);

export const getTargetDegreeData = (params) => getAction("/gkUserTargetDegree/getDegreeData",params)

export const getGkUserScore = (params) => getAction("/gkUserScore/queryBygkUserId", params);

export const getSchoolScoreRank = (params) => getAction("/gkSchool/queryBySchoolName", params);

export const aiArtList = (params) => getAction("/AISelector/aiArtList", params);

export const aiSportsList = (params) => getAction("/AISelector/aiSportsList", params);

export const aiSpringList = (params) => getAction("/AISelector/aiSpringList", params);

export const addDegree = (params) => postAction("/gkUserSchoolWork/addDegree", params);

export const deleteGkUserScore = (params) => deleteAction("/gkUserScore/delete", params);

export const updateGkUserScore = (params) => postAction("/gkUserScore/edit", params);

export const addGkUserScore = (params) => postAction("/gkUserScore/add", params);

export const updateTargetSchool = (params) => postAction("/gkUserTargetSchool/updateIntentionSchoolPc",params);

export const loginQrCode = (params) => getAction("/gkUser/loginQRcode", params);

export const getSchoolById = (params) => getAction("/gkSchool/queryById", params);

export const saveDegreeData = (params) => postAction("/gkUserTargetDegree/saveTargetDegree", params);

export const getSchoolSubjectDegree = (params) => getAction("/gkSelectSubject/getSchoolSubjectDegree", params);
